import { render } from "../../../../../../global/components/ui/UiSelect/UiMultiselectReadOnly/UiMultiselectReadOnly.pug?vue&type=template&id=9d97c158&lang=pug"
import script from "./UiDynamischeTabelleObjektkatalogDataReadOnly.js?vue&type=script&lang=js"
export * from "./UiDynamischeTabelleObjektkatalogDataReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__